import { render } from "./WTipoSuscripcion.vue?vue&type=template&id=4b6f3018&scoped=true"
import script from "./WTipoSuscripcion.vue?vue&type=script&lang=js"
export * from "./WTipoSuscripcion.vue?vue&type=script&lang=js"

import "./WTipoSuscripcion.vue?vue&type=style&index=0&id=4b6f3018&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6f3018"]])

export default __exports__